module.exports = __webpack_public_path__ + "img/A-02.c3c44ce7.png";